import React from "react";
import { cn } from "../../utils/cn";

export const Switch = ({
  checked = false,
  onChange,
  disabled = false,
  className,
  id,
  name,
  ...props
}) => {
  const handleClick = (e) => {
    if (disabled) return;
    if (onChange) {
      const nextChecked = !checked;
      const customEvent = {
        originalEvent: e,
        value: nextChecked,
        checked: nextChecked,
        target: { name, id, value: nextChecked, checked: nextChecked },
      };
      
      // If the consumer expects (newChecked, event) or (e)
      // We pass nextChecked as first arg if they expect boolean or we can make nextChecked falsy/truthy work either way.
      // But standard React event / PrimeReact pattern:
      // PrimeReact InputSwitch: onChange(e) where e.value is boolean, e.target.value is boolean
      // Tailwind simple Switch: onChange(nextChecked)
      // By passing nextChecked as first argument, if a component does onChange={(checked) => ...}, it gets a boolean!
      // To also support e.target.checked or e.value:
      // We can make nextChecked a Boolean object or pass nextChecked directly.
      // Notice: if someone does `onChange={(checked) => setIsGratuita(checked)}`,
      // `Boolean({ value: false })` is TRUE because an object is truthy in JavaScript!
      onChange(nextChecked, customEvent);
    }
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      id={id}
      name={name}
      disabled={disabled}
      onClick={handleClick}
      className={cn(
        "relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-urb-primary focus-visible:ring-offset-2 focus-visible:ring-offset-urb-dark",
        checked ? "bg-urb-primary" : "bg-slate-700",
        disabled && "opacity-50 cursor-not-allowed",
        className
      )}
      {...props}
    >
      <span
        aria-hidden="true"
        className={cn(
          "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-urb-dark shadow-lg ring-0 transition duration-200 ease-in-out",
          checked ? "translate-x-5 bg-black" : "translate-x-0 bg-slate-300"
        )}
      />
    </button>
  );
};

export default Switch;
